import React from 'react';
import { footerPropTypes } from './FooterPropTypes';
import Container from '@Theme/natucare/components/Container/Container';
import NewsletterForm from '@App/themes/natucare/components/NewsletterForm/NewsletterForm';
import Links from '@Theme/natucare/modules/Footer/components/Links/Links';
import Brand from '@Theme/natucare/modules/Footer/components/Brand/Brand';
import ContentNote from '@Theme/natucare/modules/Footer/components/ContentNote/ContentNote';
import BottomBar from '@Theme/natucare/modules/Footer/components/BottomBar/BottomBar';
import TrustmateWidget from '@Theme/natucare/modules/Footer/components/TrustmateWidget/TrustmateWidget';
import * as styles from './Footer.module.scss';
const Footer = ({
  newsletter,
  links,
  brand,
  contentNote,
  bottomBar,
  subscriptionStatus,
  onSubscribe,
  locale = 'intl'
}) => {
  if (!newsletter && !links) {
    return null;
  }

  /**
   * Prop objects with data, functions and states
   */
  const newsletterProps = {
    ...newsletter,
    subscriptionStatus,
    onSubscribe
  };
  return /*#__PURE__*/React.createElement("footer", {
    className: styles.root
  }, /*#__PURE__*/React.createElement(Container, {
    classname: styles.rootContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootMain
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootAction
  }, /*#__PURE__*/React.createElement(NewsletterForm, Object.assign({}, newsletterProps, {
    variant: "Footer"
  })), links && /*#__PURE__*/React.createElement("div", {
    className: styles.rootLinks
  }, links.map((item, index) => /*#__PURE__*/React.createElement(Links, Object.assign({}, item, {
    key: index
  }))))), /*#__PURE__*/React.createElement(Brand, brand)), /*#__PURE__*/React.createElement(TrustmateWidget, {
    locale: locale
  }), /*#__PURE__*/React.createElement(ContentNote, contentNote), /*#__PURE__*/React.createElement(BottomBar, bottomBar)));
};
export default Footer;